"use client";
import React, {
  Dispatch,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from "react";
import { getSearch } from "../wp/getSearch";
import useUpdateEffect from "../hooks/useUpdateEffect";
import { SearchType } from "../types/baseTypes";
export interface SearchContextType {
  searchPosts: SearchType;
  setSearchPosts: Dispatch<SetStateAction<SearchType>>;
  searchValue: string;
  setSearchValue: Dispatch<SetStateAction<string>>;
  currentPage: number;
  setCurrentPage: Dispatch<SetStateAction<number>>;
  loading: boolean;
  setLoading: Dispatch<SetStateAction<boolean>>;
  searchPostsPerPage: number;
  setSearchPostsPerPage: Dispatch<SetStateAction<number>>;
}
const SearchContext = createContext<SearchContextType | null>(null);

export const SearchProvider = ({ children }: { children: React.ReactNode }) => {
  // Search
  const [searchPosts, setSearchPosts] = useState<SearchType>({
    postsTotal: 0,
    posts: [],
    keyword: null,
  });
  const [searchValue, setSearchValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [searchPostsPerPage, setSearchPostsPerPage] = useState(10);

  const [loading, setLoading] = useState(false);
  const fetchPosts = async () => {
    setLoading(true);
    let searchData: SearchType = {
      postsTotal: 0,
      posts: [],
      keyword: null,
    };
    if (searchValue) {
      searchData = await getSearch({
        keyword: searchValue,
        postsPerPage: searchPostsPerPage,
        page: currentPage,
      });
    }

    setSearchPosts(searchData);
    setLoading(false);
  };
  useUpdateEffect(() => {
    fetchPosts();
    setCurrentPage(1);
  }, [searchValue]);

  useUpdateEffect(() => {
    fetchPosts();
  }, [currentPage]);

  return (
    <SearchContext.Provider
      value={{
        searchPosts,
        setSearchPosts,
        setSearchValue,
        searchValue,
        currentPage,
        setCurrentPage,
        loading,
        searchPostsPerPage,
        setSearchPostsPerPage,
        setLoading,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};

const useSearchContext = () => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error("useSearchContext must be used within a SearchProvider");
  }

  return context;
};

export { useSearchContext };
